import { forwardRef } from "react";
import styles from "./top-bottom-cutted-card.module.scss";

interface TopBottomCuttedCardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  bgImage?: string;
  watermarkSrc?: string;
  shareMode?: boolean;
}

/**
 * Generic receipt card with scalloped (cut) top/bottom edges.
 * Shared by the transaction-history detail and service-request detail pages.
 *
 * When `shareMode` (or `bgImage`) is set, a stable global class `receipt-share-mode`
 * is added to the container so consumers can scope their own "transparent children"
 * rules via `:global(.receipt-share-mode)`.
 */
export const TopBottomCuttedCard = forwardRef<HTMLDivElement, TopBottomCuttedCardProps>(
  ({ children, style, className, bgImage, watermarkSrc, shareMode }, ref) => {
    const inShareMode = shareMode || !!bgImage;
    return (
      <div
        ref={ref}
        className={`${styles.receiptContainer}${inShareMode ? " receipt-share-mode" : ""}${className ? ` ${className}` : ""}`}
        style={style}
      >
        {bgImage && (
          <div className={styles.receiptBackground}>
            <img src={bgImage} className={styles.receiptBgImg} alt="" />
          </div>
        )}
        {watermarkSrc && (
          <div className={styles.receiptWatermarkClip}>
            <div
              className={styles.receiptWatermark}
              style={{ backgroundImage: `url(${watermarkSrc})` }}
            />
          </div>
        )}
        <div className={styles.receiptContent}>
          {children}
        </div>
      </div>
    );
  }
);

TopBottomCuttedCard.displayName = "TopBottomCuttedCard";

export default TopBottomCuttedCard;
